import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertBannerComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/alert-banner';
import { MarkdownModule } from 'ngx-markdown';
import { AlertBannerComponent as component } from './component/alert-banner.component';

@NgModule({
  declarations: [component],
  exports: [component],
  imports: [CommonModule, MarkdownModule, TranslateModule, AlertBannerComponent]
})
export class AlertBannerModule {}
